/**
 * Astor priority + next-action DTOs for the consumer dashboard's
 * `ActiveLoansPanel`. Emitted by `consumer.cases.list` (deterministic
 * projection in 2-api-gateway). Centralized here so the wire shape, the
 * router projector, and the frontend renderer all reference the same types.
 */

import { z } from 'zod';

export const AstorPrioritySchema = z.enum(['urgent', 'high', 'normal', 'low']);
export type AstorPriority = z.infer<typeof AstorPrioritySchema>;

/** Who owes the next move on the case — borrower (`you`) or lender (`us`). */
export const AstorNextActionOwnerSchema = z.enum(['you', 'us']);
export type AstorNextActionOwner = z.infer<typeof AstorNextActionOwnerSchema>;

export const AstorNextActionSchema = z.object({
  /** Plain-English label for the "Next" column ("Sign disclosure", "Underwriter is reviewing"). */
  label: z.string().min(1),
  /** Who owes the next move. */
  who: AstorNextActionOwnerSchema,
  /** Optional in-portal deep-link the borrower can tap to act. */
  href: z.string().optional(),
});
export type AstorNextAction = z.infer<typeof AstorNextActionSchema>;
